import React, { useEffect } from 'react'
import {Form} from 'react-bootstrap'

interface GenderSelectorProps {
  selectedGender: 'male' | 'female' | 'any' | 'non-binary' | 'prefer-not-to-disclose'
  onGenderChange: (gender: 'male' | 'female' | 'any'| 'non-binary' | 'prefer-not-to-disclose') => void
}

const genderOptions = [
  {value: 'any', label: 'Any Gender'},
  {value: 'male', label: 'Male'},
  {value: 'female', label: 'Female'},
  {value: 'NP', label: 'Non-binary'},
  {value: 'PD', label: 'Prefer not to Disclose'},
  
]


const GenderSelector: React.FC<GenderSelectorProps> = ({selectedGender, onGenderChange}) => {
  return (
    <div>
      <Form.Label className='fw-bold'>Preferred Agent Gender</Form.Label>
      <Form.Select
        value={selectedGender}
        onChange={(e) => onGenderChange(e.target.value as 'male' | 'female' | 'any')}
      >
        {genderOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>
      <Form.Text className='text-muted'>Choose your preferred agent gender</Form.Text>
    </div>
  )
}

export default GenderSelector
